// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader___4c8U","Loader":"styles_Loader__vGIN4"};